const en = {
  common: {
    clear: 'Clear',
    cancel: 'Cancel',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    searchColumns: 'Search columns',
    showAll: 'Show all',
    hideAll: 'Hide all',
    columns: 'Columns',
    resetView: 'Reset View',
    saveView: 'Save view',
    viewSaved: 'View saved',
    viewSaveFailed: 'Could not save view',
    exportCsv: 'Export CSV',
    exportExcel: 'Export to Excel',
    noExportData: 'No data to export.',
    paginationTotal: '{{from}}-{{to}} / {{total}} records',
    column: 'Column',
    col: 'Col',
  },
  dccFileModal: {
    title: 'Select DCC file',
    titleMultiple: 'Select DCC files',
    searchFolder: 'Search folder',
    goToInitial: 'Go to initial folder',
    upOneLevel: 'Up one level',
    refresh: 'Refresh',
    path: 'Path:',
    filterPlaceholder: 'Filter listed items by name',
    empty: 'No files/folders found',
    preview: 'Preview',
    select: 'Select',
    cancel: 'Cancel',
    selectedCount: '{{total}} file(s) selected',
    selectAll: 'Select all files in this folder',
    clearSelection: 'Clear',
    selectedName: 'Selected: {{name}}',
    doubleClickHint: 'Double-click a folder to open it',
    notAuthenticated: 'Not authenticated. Please login again.',
    loadError: 'Failed to load DCC folder.',
  },
  corOcr: {
    pageTitle: 'OCR Tool',
    pageDescription:
      'Extracts text from PDFs and images. You can upload a local file, or point to an existing DCC file under `/root/uploads` by giving its path.',
    engineTitle: 'OCR engine',
    engineDescription:
      'PaddleOCR runs on the server side. If the PDF already contains selectable text, native text extraction with PyMuPDF is tried first; OCR kicks in only when needed.',
    sourceCard: 'Source File',
    localFile: 'Local File',
    serverPath: 'Server File Path',
    dropText: 'Click or drop a file here',
    dropHint: 'Supported formats: PDF, PNG, JPG, BMP, TIFF, WEBP',
    pathPlaceholder: 'E.g. temp/sample.pdf or Zimmet/2026/document.png',
    selectFromDcc: 'Select File from DCC',
    selectedServerPath: 'Selected server path: {{path}}',
    selectedFile: 'Selected file: {{name}}',
    forceOcrLabel: 'Force OCR even if the PDF contains text',
    extract: 'Extract Text',
    resultCard: 'OCR Result',
    engine: 'Engine',
    source: 'Source',
    pages: 'Pages',
    chars: 'Characters',
    resultPlaceholder: 'OCR output will appear here.',
    noResult: 'No OCR result yet.',
    msgNoSession: 'Session not found. Please log in again.',
    msgSelectFile: 'Please select a file.',
    msgEnterPath: 'Please enter the server file path.',
    msgDone: 'OCR completed.',
    msgFailed: 'OCR operation failed.',
  },
  corPdfExtract: {
    pageTitle: 'PDF Text Extractor',
    pageDescription:
      'Extracts text from PDF files on the backend. You can either upload a local PDF or select an existing PDF from the DCC file server.',
    engineTitle: 'Text extraction engine',
    engineDescription:
      'On the server, PDF content is first read as native text; OCR is used only if necessary. All processing happens on the backend, this page only displays the extracted text.',
    sourceCard: 'Source PDF',
    localPdf: 'Local PDF',
    serverPdf: 'Server PDF',
    dropText: 'Click or drag a PDF file to this area to upload',
    dropHint: 'Only .pdf files are supported.',
    pathPlaceholder: 'Example: temp/forms/form1.pdf',
    selectFromDcc: 'Select PDF from DCC',
    selectedServerPath: 'Selected server path: {{path}}',
    selectedFile: 'Selected file: {{name}}',
    extract: 'Extract Text',
    outputCard: 'PDF Text Output',
    outputPlaceholder: 'Extracted text will appear here.',
    noResult: 'No text has been extracted yet.',
    msgNoSession: 'Session not found. Please log in again.',
    msgSelectFile: 'Please select a PDF file.',
    msgEnterPath: 'Please select the PDF path on the server.',
    msgDone: 'PDF text extracted.',
    msgFailed: 'An error occurred while extracting PDF text.',
  },
  persFihrist: {
    title: 'Phone Book',
    printTooltip: 'Print Phone Book',
    printTitle: 'Phone Book',
    searchPlaceholder: 'Search by First Name, Last Name, Phone, Occupation, Company...',
    colFirstName: 'First Name',
    colLastName: 'Last Name',
    colCompany: 'Company',
    colOccupation: 'Occupation',
    colPhone: 'Phone',
    colExtension: 'Extension Number',
  },
  admPersonnel: {
    editTitle: 'Edit Personnel',
    edit: 'Edit',
    back: 'Back to List',
    save: 'Save',
    cancel: 'Cancel',
    loading: 'Loading personnel details...',
    notFound: 'Personnel not found',
    loadError: 'Could not load personnel details',
    loadErrorDesc: 'Please try again later.',
    updated: '{{name}} updated',
    updateError: 'Update failed: {{error}}',
    required: '{{field}} is required',
    invalidEmail: 'Enter a valid email',
    uCodePattern: 'Letter + digits (e.g. u14175)',
    select: 'Select',
    occupationNeedsClass: 'Select labor class first',
    noOccupation: 'No matching occupation',
    yearsOld: '{{age}} years old',
    recordInfo: 'Record #{{id}} · Created: {{date}}',
    sections: {
      personal: 'Personal Information',
      contact: 'Contact',
      employment: 'Employment',
      identity: 'Identity & Equipment',
      assets: 'Active Assets',
      entitlements: 'Leave & Travel Entitlements',
    },
    fields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      gender: 'Gender',
      dateOfBirth: 'Date of Birth',
      nationality: 'Nationality',
      bloodType: 'Blood Type',
      email: 'Email',
      phone: 'Phone',
      extension: 'Extension',
      emergencyContact: 'Emergency Contact',
      company: 'Company',
      department: 'Department',
      position: 'Position',
      laborClass: 'Labor Class',
      occupation: 'Occupation',
      hireDate: 'Hire Date',
      terminationDate: 'Termination Date',
      status: 'Status',
      persId: 'Personnel ID',
      sapNo: 'SAP No',
      uCode: 'U Code',
      passportNo: 'Passport No',
      bodySize: 'Body Size',
      shoeSize: 'Shoe Size',
    },
    enums: {
      active: 'Active',
      inactive: 'Inactive',
      terminated: 'Terminated',
      M: 'Male',
      F: 'Female',
      yes: 'Yes',
      no: 'No',
    },
    assets: {
      code: 'Asset Code',
      serial: 'Serial No',
      model: 'Model',
      variant: 'Variant',
      brand: 'Brand',
      notes: 'Notes',
      assignedAt: 'Assigned On',
      empty: 'No active assets',
    },
  },
  admMeters: {
    list: {
      title: 'Meters',
      addMeter: 'Add Meter',
      colRoomId: 'Room ID',
      colType: 'Meter Type',
      colSerial: 'Serial Number',
      colStatus: 'Status',
      colActions: 'Actions',
      details: 'Details',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this meter?',
      yes: 'Yes',
      no: 'No',
      loadError: 'Failed to load meter data.',
      deleteSuccess: 'Meter deleted.',
      deleteError: 'Failed to delete meter.',
    },
    form: {
      editTitle: 'Edit Meter',
      addTitle: 'Add New Meter',
      roomLabel: 'Building/Room',
      roomRequired: 'Please select a room!',
      roomPlaceholder: 'Select a room',
      typeLabel: 'Counter Type',
      typeRequired: 'Please enter the counter type!',
      typePlaceholder: 'Select counter type',
      unitLabel: 'Unit',
      unitRequired: 'Please select or enter a unit!',
      unitExtra: 'Example: kWh, m³, GJ, kcal, ...',
      unitPlaceholder: 'Enter unit (e.g. kWh, m³, GJ)',
      serialLabel: 'Serial Number',
      serialRequired: 'Please enter the serial number!',
      statusLabel: 'Status',
      statusRequired: 'Please select a status!',
      statusPlaceholder: 'Select a status',
      initialValueLabel: 'Initial Value',
      initialValueTooltip: 'The value the meter showed when first installed. (Default: 0)',
      initialValuePlaceholder: 'Default: 0',
      multiplierLabel: 'Multiplier',
      multiplierTooltip: 'Reading values are multiplied by this factor. (Default: 1)',
      multiplierPlaceholder: 'Default: 1',
      update: 'Update',
      save: 'Save',
      roomsError: 'Error fetching room data.',
      meterError: 'Error fetching meter details.',
      updateSuccess: 'Meter updated successfully.',
      addSuccess: 'Meter added successfully.',
      opError: 'An error occurred during the operation.',
    },
    bulk: {
      title: 'Monthly Meter Reading Entry',
      lockedInfo:
        'Meter value and note fields are locked for previously entered days. Press the Edit button on the relevant row to modify.',
      selectMeterLabel: 'Select Meter:',
      selectMeterPlaceholder: 'Select a meter',
      monthLabel: 'Month:',
      lastValue: 'Last Meter Value',
      selectMeterAlert: 'Please select a meter to enter readings.',
      colDate: 'Date',
      colValue: 'Meter Value',
      colValueWithUnit: 'Meter Value ({{unit}})',
      edit: 'Edit',
      valuePlaceholder: 'Value',
      valuePlaceholderWithUnit: 'Value ({{unit}})',
      colNote: 'Note',
      notePlaceholder: 'Optional note',
      colPrev: 'Previous Value',
      colDaily: 'Daily Usage',
      invalid: 'Invalid!',
      fetchError: 'Failed to fetch meters.',
      readingsFetchError: 'Failed to fetch existing readings.',
      saveDayError: 'Failed to save the reading for {{date}}',
      saveSuccess: 'Readings saved successfully!',
      nothingToSave: 'No readings to save.',
      chainWarning: 'Values on some days are lower than the previous day: {{days}}. These days were not saved!',
      saveAll: 'Save All Readings',
    },
  },
  folderManager: {
    title: 'Folder Manager',
    listError: 'List cannot be obtained!',
    serverError: 'Server not accessible!',
    enterFolderName: 'Please enter a folder name',
    folderCreated: 'Folder Created!',
    deleteConfirm: 'Are you sure you want to delete?',
    yes: 'Yes',
    no: 'No',
    deleted: 'Deleted!',
    deleteFailed: 'Delete failed',
    moveSuccess: 'Move successful!',
    copySuccess: 'Copy successful!',
    copyFailed: 'Copy failed',
    colName: 'Folder Name',
    colCreated: 'Created Date',
    colActions: 'Actions',
    move: 'Move',
    copy: 'Copy',
    delete: 'Delete',
    download: 'Download',
    preview: 'Preview',
    parentFolder: 'Parent Folder',
    newFolderPlaceholder: 'New Folder Name',
    create: 'Create',
    loading: 'Loading...',
    empty: 'Folder Empty.',
    moveTitle: 'Move operation',
    movePlaceholder: 'New Path (eg: Folder/Subfolder)',
    copyTitle: 'Copy',
    copyPlaceholder: 'Target path (eg: folder/subfolder/file.pdf)',
    cancel: 'Cancel',
  },
  chemicalMaterials: {
    pageTitle: 'Chemical Material List',
    loadError: 'Failed to load chemical materials.',
    deleteSuccess: 'Material deleted.',
    deleteError: 'Delete failed.',
    updateSuccess: 'Existing material updated (quantities summed)!',
    addSuccess: 'New material added successfully!',
    unexpectedError: 'An unexpected error occurred!',
    colMaterialNo: 'Material No',
    colDescription: 'Description',
    colQuantity: 'Quantity',
    colUnit: 'Unit',
    colSupplier: 'Supplier',
    col12Month: '12-Month Requirement',
    colRemaining: 'Remaining Stock',
    colCreatedAt: 'Created At',
    quickAddTitle: 'Quick Add Material',
    required: 'Required',
    add: 'Add',
    downloadExcel: 'Download Excel Template',
    downloadCsv: 'Download CSV Template',
    uploadInfoTitle: 'Upload Information:',
    uploadInfoFormat: 'File format can be CSV or Excel (.xlsx).',
    uploadRequiredHeaders: 'Required headers:',
    uploadInfoUnitValues:
      'Accepted values and descriptions for the unit field are on the second sheet of the template (or in the table below).',
    uploadInfoUnitNames: 'You can use the unit name or its symbol. See the template for details.',
    globalSearchPlaceholder: 'Global search (all fields)',
    unitFilterPlaceholder: 'Unit filter',
    supplierSearchPlaceholder: 'Search supplier',
    printList: 'Print List',
  },
  header: {
    language: 'Language',
    goHome: 'Home',
    assignedTasks: 'Assigned tasks',
    goToProfile: 'Go to profile',
    logout: 'Logout',
    login: 'Login',
    userPrefix: 'User',
  },
  auth: {
    loginTitle: 'User login',
    username: 'Username',
    password: 'Password',
    usernameRequired: 'Please enter your username',
    passwordRequired: 'Please enter your password',
    loginSuccess: 'Login successful',
    loginError: 'Invalid username or password.',
  },
  home: {
    appTitle: 'Project Information Platform',
    weatherNow: 'Weather now',
    wind: 'Wind',
    humidity: 'Humidity',
    pressure: 'Pressure',
    precipitation: 'Precip.',
    noWeatherData: 'No weather data',
    projectTimeline: 'Project timeline',
    start: 'Start',
    end: 'End',
    elapsed: 'Elapsed',
    timeRemaining: 'Time remaining',
    years: 'Years',
    months: 'Months',
    days: 'Days',
    daysRemaining: '{{count}} days remaining',
    openModule: 'Open {{module}}',
    todaysMenu: "Today's Menu",
    lunch: 'Lunch',
    dinner: 'Dinner',
    noMenuToday: 'No menu entered for today',
    myTasks: 'My Pending Work',
    tasksEmpty: 'No pending work 🎉',
    tasksLoginPrompt: 'Sign in to see your tasks',
    viewAllTasks: 'View all',
  },
  tasks: {
    title: 'My Tasks',
    filterPending: 'Pending',
    filterCompleted: 'Completed',
    filterAll: 'All',
    colType: 'Type',
    colDescription: 'Description',
    colStatus: 'Status',
    colCreated: 'Created',
    go: 'Open',
    complete: 'Complete',
    completedMsg: 'Task completed',
    empty: 'No tasks found',
    typeAction: 'Approval',
    typeNotify: 'Info',
    status: {
      pending: 'Pending',
      'in progress': 'In progress',
      blocked: 'Queued',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
  },
  kitchen: {
    recipes: {
      title: 'Recipe List',
      createNew: 'Create New Recipe',
      searchByName: 'Search by Name',
      selectCategory: 'Select Category',
      selectCuisine: 'Select Cuisine',
      selectStatus: 'Select Recipe Status',
      allCategories: 'All Categories',
      allCuisines: 'All Cuisines',
      allStatuses: 'All Statuses',
      colName: 'Recipe Name',
      colCategory: 'Category',
      colCuisine: 'Cuisine',
      colServingSize: 'Serving Size',
      colPrep: 'Prep (min)',
      colCook: 'Cook (min)',
      colStatus: 'Status',
      colActions: 'Actions',
      deleteConfirmTitle: 'Confirm Deletion',
      deleteConfirmContent:
        'Are you sure you want to delete the recipe "{{name}}" (ID: {{id}}) and all its associated ingredients?',
      deleteIrreversible: 'This action cannot be undone.',
      deleteOk: 'Delete',
      deleteCancel: 'Cancel',
      deleteSuccess: 'Recipe ID {{id}} and its associated ingredients deleted successfully!',
      deleteMaybeFailed:
        'Recipe ID {{id}} might not have been deleted (or ingredient deletion failed). Response: {{msg}}',
      deleteError: 'Failed to complete deletion for Recipe ID {{id}}: {{error}}',
      loadErrorTitle: 'Error',
      loadError: 'Failed to load recipes: {{error}}',
    },
    mealType: {
      Breakfast: 'Breakfast',
      Lunch: 'Lunch',
      Dinner: 'Dinner',
      Snack: 'Snack',
      Suhoor: 'Suhoor',
      Iftar: 'Iftar',
      Event: 'Event',
      Package: 'Package',
    },
    weekly: {
      title: 'Weekly Menu Planner',
      prevWeek: 'Previous',
      nextWeek: 'Next',
      copyPrevWeek: 'Copy Last Week',
      copyPrevWeekDone: "Last week's menu copied (don't forget to save)",
      copyPrevWeekEmpty: 'No menu found for last week',
      saveWeek: 'Save Week',
      saved: 'Weekly menu saved',
      saveError: 'Error while saving: {{error}}',
      unsaved: 'You have unsaved changes',
      visibleMeals: 'Visible meals',
      servings: 'Servings',
      selectRecipes: 'Select dishes...',
      copyDay: 'Copy this day',
      day: 'Day',
      meal: 'Meal',
      course: 'Course {{n}}',
      loadError: 'Failed to load menu data',
    },
  },
  machinery: {
    allocations: {
      createTitle: 'Machine Reservation / Allocation Create',
      viewTitle: 'Machine Reservation / Allocation Detail',
      selectWpOrActivity: 'Please select a Work Permit or an Activity',
      activityMissing: 'Activity Code / Name is missing. Please complete the selection.',
      overlapFrontend:
        'The selected time range overlaps with existing reservations for this machine. Please pick a different range.',
      noIdReturned: 'Record ID was not returned',
      createSuccess: 'Reservation request created successfully.',
      overlapDb:
        'A reservation already exists for this machine in the selected time range. Please pick a different time range.',
      createFailed: 'Failed to create reservation',
      startTime: 'Start Time',
      startTimeRequired: 'Please select a start time',
      endTime: 'End Time',
      endTimeRequired: 'Please select an end time',
      machine: 'Machine',
      machineRequired: 'Please select a machine',
      machinePlaceholder: 'Select machine',
      company: 'Company',
      companyRequired: 'Please select a company',
      companyPlaceholder: 'Select company',
      existingTitle: 'Selected Machine - Existing Reservations',
      existingHint: 'Please select a machine to see its existing reservations.',
      existingEmpty: 'No reservations exist for this machine yet.',
      colStart: 'Start',
      colEnd: 'End',
      colStatus: 'Status',
      requester: 'Requester',
      requesterRequired: 'Please select the requesting personnel',
      requesterPlaceholder: 'Select requester',
      approver: 'Approver',
      approverRequired: 'Please select the approving personnel',
      approverPlaceholder: 'Select approver',
      location: 'Location',
      locationRequired: 'Please enter a location',
      description: 'Description',
      descriptionRequired: 'Please enter a description',
      descriptionPlaceholder: 'Description of the work to be done',
      wpActivityTitle: 'Work Permit / Activity',
      pickWorkPermit: 'Pick Work Permit',
      wpPlaceholder: 'WP Ref - Desc',
      clear: 'Clear',
      pickActivity: 'Pick Activity',
      activityCombinedPlaceholder: 'Activity Code - Name',
      activityCode: 'Activity Code',
      activityName: 'Activity Name',
      cancel: 'Cancel',
      createReservation: 'Create Reservation',
      recordNotFound: 'Record not found',
      recordLoadFailed: 'Failed to load record',
      onlyApprover: 'Only the assigned approver can change the reservation status.',
      statusUpdated: 'Status updated to {{status}}',
      statusUpdateFailed: 'Failed to update status',
      cancelConfirm: 'Are you sure you want to cancel this reservation?',
      cancelOk: 'Yes, cancel it',
      rejectConfirm: 'Are you sure you want to reject this reservation?',
      rejectOk: 'Yes, reject',
      no: 'No',
      selectNewTimes: 'Please select new start and end times',
      endAfterStart: 'End time must be after the start time',
      backToList: 'Back to list',
      approve: 'Approve',
      defer: 'Defer',
      reject: 'Reject',
      workPermitRef: 'Work Permit Ref',
      activity: 'Activity',
      deferTitle: 'Defer Reservation',
      save: 'Save',
      newStart: 'New start time',
      newEnd: 'New end time',
      unknown: 'Unknown',
    },
    hub: {
      title: 'Machinery',
      description: 'Main access screen for machinery operations. Provides quick navigation without adding extra data load.',
      subtitle: 'Maintenance, vehicles, reservations, forms, and fuel tracking can be managed here.',
      operation: 'Operations',
      maintenanceAndRecords: 'Maintenance And Records',
      formsAndFuel: 'Forms And Fuel',
      goToScreen: 'Go to screen',
      tags: {
        list: 'List',
        detail: 'Detail',
        vehicle: 'Vehicle',
        user: 'User',
        reservation: 'Reservation',
        request: 'Request',
        personnel: 'Personnel',
        assignment: 'Assignment',
        maintenance: 'Maintenance',
        record: 'Record',
        definition: 'Definition',
        class: 'Class',
        period: 'Period',
        threshold: 'Threshold',
        alert: 'Alert',
        tracking: 'Tracking',
        form: 'Form',
        import: 'Import',
      },
      cards: {
        machines: {
          title: 'Machine Fleet',
          subtitle: 'Machines',
          description: 'Machine list, details, and equipment tracking.',
        },
        vehicles: {
          title: 'Vehicles',
          subtitle: 'Vehicles',
          description: 'Vehicle records, user assignments, and overall status tracking.',
        },
        allocations: {
          title: 'Reservations / Allocation',
          subtitle: 'Reservations / Allocation',
          description: 'Machine reservations and allocation processes.',
        },
        assignments: {
          title: 'Assignments',
          subtitle: 'Assignments',
          description: 'Personnel-based vehicle usage assignments.',
        },
        maintenance: {
          title: 'Maintenance Records',
          subtitle: 'Maintenance',
          description: 'Maintenance entries, history, and process tracking.',
        },
        maintenanceTypes: {
          title: 'Maintenance Types',
          subtitle: 'Maintenance Types',
          description: 'Maintenance classes and applicable machine types.',
        },
        maintenanceRules: {
          title: 'Maintenance Rules',
          subtitle: 'Maintenance Rules',
          description: 'Period, threshold, and alert rule management.',
        },
        maintenanceAlerts: {
          title: 'Maintenance Alerts',
          subtitle: 'Maintenance Alerts',
          description: 'Visibility of upcoming and overdue maintenance needs.',
        },
        forms: {
          title: 'Forms',
          subtitle: 'Forms',
          description: 'Machine forms, definitions, and record details.',
        },
        fuel: {
          title: 'Fuel Tracking',
          subtitle: 'Fuel Tracking',
          description: 'Fuel movements, history, and import screens.',
        },
      },
    },
    machines: {
      common: {
        cancel: 'Cancel',
        save: 'Save',
        yes: 'Yes',
        no: 'No',
      },
    },
    vehicles: {
      common: {
        available: 'Available',
        assigned: 'Assigned',
        inMaintenance: 'In Maintenance',
        outOfService: 'Out of Service',
        inactive: 'Inactive',
      },
    },
    fuel: {
      common: {
        import: 'Fuel Import',
        overviewTab: 'Overview',
        entryTab: 'Fuel Entry',
        historyTab: 'Fuel History',
        pumpsTab: 'Pump Management',
        transfersTab: 'Stock Transfers',
      },
      import: {
        title: 'Fuel Records Import',
        description: 'You can bulk upload fuel entries to',
        descriptionSuffix: 'using an Excel/CSV file.',
        expectedColumns: 'Expected columns',
        required: '(required)',
      },
      entry: {
        title: 'Fuel Entry Form',
        vehicle: 'Vehicle',
        vehicleRequired: 'Please select a vehicle',
        vehiclePlaceholder: 'Select vehicle',
        vehicleFuelType: 'Vehicle Fuel Type',
        personnel: 'Personnel',
        personnelRequired: 'Please select personnel',
        personnelPlaceholder: 'Select personnel',
        date: 'Date',
        dateRequired: 'Please select a date',
        odometer: 'Odometer',
        hourCounter: 'Hour Counter',
        liters: 'Fuel (L)',
        litersRequired: 'Please enter liters',
        fuelType: 'Fuel Type',
        fuelTypeRequired: 'Please select fuel type',
        fuelTypePlaceholder: 'Select fuel type',
        sourceType: 'Source Type',
        sourceTypeRequired: 'Please select source type',
        sourceTypePlaceholder: 'Select source type',
        sourceTypeFixedPump: 'Fixed Pump',
        sourceTypeFuelTanker: 'Fuel Tanker',
        sourceTypeExternal: 'External Source',
        sourcePump: 'Pump',
        sourcePumpRequired: 'Please select pump',
        sourcePumpPlaceholder: 'Select pump',
        sourceTanker: 'Tanker',
        sourceTankerRequired: 'Please select tanker',
        sourceTankerPlaceholder: 'Select tanker',
        sourceName: 'Source Name',
        sourceNameRequired: 'Please enter source name',
        sourceNamePlaceholder: 'Enter source name',
        location: 'Location',
        locationPlaceholder: 'Enter location',
        referenceNo: 'Reference No',
        referenceNoPlaceholder: 'Enter reference no',
        station: 'Station',
        stationPlaceholder: 'Enter station',
        company: 'Company',
        companyPlaceholder: 'Enter company',
        note: 'Note',
        notePlaceholder: 'Enter note',
        currentKilometer: 'Current KM',
        currentHours: 'Current Hours',
        save: 'Save',
        addSuccess: 'Fuel entry added',
        addFailed: 'Fuel entry could not be added: {{message}}',
      },
      history: {
        title: 'Fuel History',
        searchPlaceholder: 'Search vehicle, personnel, company, station, or note...',
        vehiclePlaceholder: 'Vehicle',
        sourceTypePlaceholder: 'Source type',
        refresh: 'Refresh',
        vehicle: 'Vehicle',
        date: 'Date',
        personnel: 'Personnel',
        fuelType: 'Fuel Type',
        sourceType: 'Source Type',
        source: 'Source',
        sourceTypeFixedPump: 'Fixed Pump',
        sourceTypeFuelTanker: 'Fuel Tanker',
        sourceTypeExternal: 'External Source',
        odometer: 'Odometer',
        hourCounter: 'Hour Counter',
        liters: 'Liters',
        company: 'Company',
        station: 'Station',
        location: 'Location',
        referenceNo: 'Reference No',
        note: 'Note',
      },
      pumps: {
        title: 'Fuel Pumps',
        addButton: 'New Pump',
        addTitle: 'New Pump',
        editTitle: 'Edit Pump',
        searchPlaceholder: 'Search pump name, code, location, or company...',
        name: 'Pump Name',
        nameRequired: 'Please enter pump name',
        namePlaceholder: 'Enter pump name',
        code: 'Code',
        codePlaceholder: 'Enter pump code',
        fuelType: 'Fuel Type',
        fuelTypeRequired: 'Please select fuel type',
        fuelTypePlaceholder: 'Select fuel type',
        location: 'Location',
        locationPlaceholder: 'Enter location',
        capacityLiters: 'Capacity (L)',
        openingStockLiters: 'Opening Stock (L)',
        openingStockRequired: 'Please enter opening stock',
        status: 'Status',
        statusRequired: 'Please select status',
        statusPlaceholder: 'Select status',
        statusActive: 'Active',
        statusInactive: 'Inactive',
        statusOutOfService: 'Out Of Service',
        company: 'Company',
        companyPlaceholder: 'Select company',
        note: 'Note',
        notePlaceholder: 'Enter note',
        addSuccess: 'Pump record added',
        updateSuccess: 'Pump record updated',
        operationFailed: 'Pump operation failed: {{message}}',
      },
      transfers: {
        title: 'Fuel Source Transfers',
        addButton: 'New Transfer',
        addTitle: 'New Fuel Transfer',
        searchPlaceholder: 'Search source, target, reference, or location...',
        date: 'Date',
        dateRequired: 'Please select date',
        sourceType: 'Source Type',
        sourceTypeRequired: 'Please select source type',
        sourceTypePlaceholder: 'Select source type',
        sourceTypeMainDepot: 'Main Depot',
        sourceTypeFixedPump: 'Fixed Pump',
        sourceTypeFuelTanker: 'Fuel Tanker',
        sourceTypeExternalSupplier: 'External Supplier',
        sourceTypeAdjustment: 'Stock Adjustment',
        source: 'Source',
        sourcePump: 'Source Pump',
        sourcePumpRequired: 'Please select source pump',
        sourcePumpPlaceholder: 'Select source pump',
        sourceTanker: 'Source Tanker',
        sourceTankerRequired: 'Please select source tanker',
        sourceTankerPlaceholder: 'Select source tanker',
        sourceName: 'Source Name',
        sourceNameRequired: 'Please enter source name',
        sourceNamePlaceholder: 'Enter source name',
        targetType: 'Target Type',
        targetTypeRequired: 'Please select target type',
        targetTypePlaceholder: 'Select target type',
        targetTypeFixedPump: 'Fixed Pump',
        targetTypeFuelTanker: 'Fuel Tanker',
        target: 'Target',
        targetPump: 'Target Pump',
        targetPumpRequired: 'Please select target pump',
        targetPumpPlaceholder: 'Select target pump',
        targetTanker: 'Target Tanker',
        targetTankerRequired: 'Please select target tanker',
        targetTankerPlaceholder: 'Select target tanker',
        fuelType: 'Fuel Type',
        fuelTypeRequired: 'Please select fuel type',
        fuelTypePlaceholder: 'Select fuel type',
        liters: 'Liters',
        litersRequired: 'Please enter liters',
        personnel: 'Personnel',
        personnelPlaceholder: 'Select personnel',
        company: 'Company',
        companyPlaceholder: 'Select company',
        location: 'Location',
        locationPlaceholder: 'Enter location',
        referenceNo: 'Reference No',
        referenceNoPlaceholder: 'Enter reference no',
        note: 'Note',
        notePlaceholder: 'Enter note',
        addSuccess: 'Transfer record added',
        operationFailed: 'Transfer operation failed: {{message}}',
        sameSourceTargetError: 'Source and target cannot be the same.',
      },
      overview: {
        title: 'Fuel Overview',
        stockTitle: 'Pump And Tanker Stock Overview',
        vehicleConsumptionTitle: 'Vehicle Consumption Summary',
        ledgerTitle: 'Source Movement Ledger',
        fuelTypePlaceholder: 'Fuel type',
        assetPlaceholder: 'Select asset',
        totalDispensedRange: 'Dispensed In Range (L)',
        totalTransferredRange: 'Transferred In Range (L)',
        totalClosingStock: 'Total Closing Stock (L)',
        totalAssetsTracked: 'Tracked Assets',
        assetType: 'Asset Type',
        assetTypePump: 'Pump',
        assetTypeTanker: 'Tanker',
        assetName: 'Asset',
        fuelType: 'Fuel Type',
        status: 'Status',
        location: 'Location',
        openingStock: 'Opening Stock',
        incomingRange: 'Incoming In Range',
        outgoingRange: 'Outgoing In Range',
        dispensedRange: 'Dispensed In Range',
        closingStock: 'Closing Stock',
        vehicle: 'Vehicle',
        totalLiters: 'Total Liters',
        entryCount: 'Entries',
        avgLiters: 'Avg. Liters',
        kmDelta: 'KM Delta',
        litersPer100Km: 'L / 100 KM',
        hoursDelta: 'Hours Delta',
        litersPerHour: 'L / Hour',
        lastEntryDate: 'Last Entry',
        referenceNo: 'Reference No',
        note: 'Note',
        ledgerDate: 'Date',
        ledgerMovementType: 'Movement Type',
        ledgerTransferIn: 'Transfer In',
        ledgerTransferOut: 'Transfer Out',
        ledgerDispense: 'Dispensed To Vehicle',
        ledgerSource: 'Source',
        ledgerTarget: 'Target',
        ledgerIn: 'In',
        ledgerOut: 'Out',
        ledgerBalance: 'Balance',
      },
    },
    maintenance: {
      common: {
        maintenanceType: 'Maintenance Type',
        description: 'Description',
        vehicle: 'Vehicle',
        status: 'Status',
        date: 'Date',
        type: 'Type',
        searchNameDescription: 'Search name/description...',
        operationFailed: 'Operation failed',
      },
      types: {
        title: 'Maintenance Types',
        addButton: 'New Type',
        name: 'Name',
        applicableTypes: 'Applicable Types',
        duplicateName: 'A maintenance type with the same name already exists',
        updateSuccess: 'Maintenance type updated',
        addSuccess: 'Maintenance type added',
        editTitle: 'Edit Maintenance Type',
        addTitle: 'New Maintenance Type',
        nameRequired: 'Name is required',
        namePlaceholder: 'E.g. Periodic Maintenance',
        applicableTypesLabel: 'Applicable Machine Types',
        applicableTypesPlaceholder: 'Select machine types (optional)',
      },
      rules: {
        title: 'Maintenance Rules',
        addButton: 'New Rule',
        searchPlaceholder: 'Search maintenance type...',
        typePlaceholder: 'Maintenance Type',
        intervalKm: 'Interval (KM)',
        intervalHours: 'Interval (Hours)',
        intervalDays: 'Interval (Days)',
        warningKm: 'Warning KM',
        warningHours: 'Warning Hours',
        warningDays: 'Warning Days',
        typeRequired: 'Maintenance type is required',
        selectPlaceholder: 'Select',
        minOneInterval: 'At least one maintenance interval must be entered',
        warningKmTooHigh: 'Warning KM cannot be greater than the maintenance interval',
        warningHoursTooHigh: 'Warning hours cannot be greater than the maintenance interval',
        warningDaysTooHigh: 'Warning days cannot be greater than the maintenance interval',
        duplicateRule: 'A rule already exists for this maintenance type',
        updateSuccess: 'Rule updated',
        addSuccess: 'Rule added',
        editTitle: 'Edit Rule',
        addTitle: 'New Rule',
      },
      list: {
        title: 'Maintenance Records',
        addButton: 'New Maintenance',
        searchPlaceholder: 'Search vehicle, maintenance type, or description...',
        vehiclePlaceholder: 'Vehicle',
        typePlaceholder: 'Maintenance Type',
        maintenanceDate: 'Maintenance Date',
        performedKm: 'Performed KM',
        performedHours: 'Performed Hours',
        deleteConfirm: 'Are you sure you want to delete this maintenance record?',
        deleteSuccess: 'Maintenance record deleted',
        deleteFailed: 'Record could not be deleted',
        updateSuccess: 'Maintenance record updated',
        addSuccess: 'Maintenance record added',
        addFailed: 'Record could not be added',
        editTitle: 'Edit Maintenance Record',
        addTitle: 'New Maintenance',
        vehicleRequired: 'Vehicle is required',
        vehicleSelectPlaceholder: 'Select vehicle',
        typeSelectPlaceholder: 'Select type (optional)',
        dateRequired: 'Date is required',
      },
      alerts: {
        title: 'Maintenance Alerts',
        searchPlaceholder: 'Search vehicle, maintenance type, or note...',
        vehiclePlaceholder: 'Vehicle',
        typePlaceholder: 'Maintenance Type',
        statusPlaceholder: 'Status',
        dueDate: 'Due Date',
        dueKm: 'Due KM',
        dueHours: 'Due Hours',
        note: 'Note',
        approaching: 'Approaching',
        due: 'Due',
        overdue: 'Overdue',
      },
    },
  },
  routes: {
    core: {
      general: 'General',
      currencies: 'Currencies',
      units: 'Units',
      countries: 'Countries',
      foodIngredients: 'Food Ingredients',
      professions: 'Professions',
      folderUploads: 'Folder uploads',
      whiteboard: 'Whiteboard',
      apiEndpoints: 'API Endpoints',
      imageCompressor: 'Image Compressor',
      pdfToReact: 'PDF to React Form',
      pdfToSvg: 'PDF to SVG',
      pdfTextExtract: 'PDF Text Extract',
      exifReader: 'Photo EXIF Reader',
    },
    dcc: {
      ocr: 'OCR',
    },
  },
  coreGeneral: {
    title: 'General',
    subtitle: 'Reference lists and shared tools.',
    currenciesHint: 'Codes and symbols',
    unitsHint: 'Units of measure',
    countriesHint: 'Country records',
    foodIngredientsHint: 'Ingredient catalog',
    professionsHint: 'Professions and labor types',
    pdfToReactHint: 'Build a form from a PDF',
    pdfToSvgHint: 'Convert a PDF page to SVG',
    pdfTextExtractHint: 'Pull text out of a PDF',
    exifReaderHint: 'Read photo metadata',
    empty: 'No lists are available for this account.',
  },
  coreWhiteboard: {
    title: 'Whiteboard',
    description:
      'This first version is single-user and does not persist drawings. The page loads only when opened, so it does not add unnecessary weight to the main application.',
    info: 'Drawings are not saved to the project database or file system in this version.',
  },
  coreFolderUploads: {
    pageTitle: 'Folder uploads',
    pageSubtitle:
      'Browse folders on the left; on the right, add files or folders and upload the full selection to the current target in one batch.',
    breadcrumbRoot: 'Root',
    columnFolder: 'Folder',
    columnType: 'Type',
    typeFolder: 'Folder',
    typeFile: 'File',
    listTitle: 'Server folders',
    refresh: 'Refresh',
    loadingFoldersTip: 'Loading folders…',
    emptyFolders: 'No folders found.',
    searchPlaceholder: 'Search folders in this path…',
    emptyFiltered: 'No folder names match your search.',
    uploadCardTitle: 'Upload',
    uploadTargetLabel: 'Upload destination',
    tagServer: 'Server',
    hintRootTarget:
      'Root upload directory is selected. Open a subfolder on the left to upload into a specific path.',
    hintSubPathPrefix: 'Selected subpath:',
    browseHint:
      'To change the upload target, open a subfolder by clicking it{{syncSuffix}}.',
    browseHintSyncOn: ' (destination updates automatically)',
    browseHintSyncOff: '; if the destination is fixed, use the button above',
    syncCheckbox: 'Keep upload target in sync while browsing',
    setBrowseAsTarget: 'Use current folder as upload target',
    targetSetSuccess: 'Upload target set to the folder you are viewing.',
    alertTitleMismatch: 'Upload target differs from browse location',
    labelDisplayed: 'Displayed:',
    labelFilesGoTo: 'Files will be written to:',
    newFolderPlaceholder: 'New folder name',
    createFolder: 'Create folder',
    goUp: 'Parent folder',
    uploadModeFiles: 'File mode',
    uploadModeFolders: 'Folder mode',
    uploadClickOrDragFiles: 'Click or drag files here to select them',
    uploadClickOrDragFolders: 'Click to add a folder, or drag several folders here',
    uploadHintFiles: 'Multi-file selection and drag-and-drop are supported.',
    uploadHintFolders: 'Folders that contain only files are included. Drag several folders here together to add them in one step.',
    selectMultipleFolders: 'Select multiple folders',
    addOneFolder: 'Add one folder',
    chooseChildFoldersTitle: 'Folders inside {{name}}',
    chooseChildFoldersHint: 'Tick the folders to include. Each selected folder is added with its files and subfolders.',
    chooseChildFoldersOk: 'Add selected folders',
    selectAllFolders: 'Select all',
    clearFolderChecks: 'Clear',
    pickerMultiUnsupported: 'This browser cannot list folders for multi-select. Drag the folders onto the area instead.',
    noChildFolders: 'That folder has no subfolders.',
    chooseChildFoldersEmpty: 'Select at least one folder.',
    uploadSelected: 'Upload selected',
    clearSelection: 'Clear',
    pendingFilesTag: 'Queued files: {{count}}',
    pendingFoldersTag: 'Queued folders: {{count}}',
    pendingLooseFilesTag: 'Loose files: {{count}}',
    pendingReadyHint: 'All selected files and folders will be uploaded together in one batch.',
    pendingEmptyHint: 'No files or folders have been added to the upload queue yet.',
    folderMultiHint:
      'Each click adds the folder you select, even when it has no subfolders. To add several of those folders together, select them in File Explorer and drag them onto this area.',
    dropReleaseFolders: 'Release to add the folders',
    dropReleaseFiles: 'Release to add the files',
    progressReading: 'Reading files…',
    progressPacking: 'Building the archive…',
    progressUploading: 'Uploading…',
    readingDropped: 'Reading dropped folders…',
    removeQueued: 'Remove from queue',
    queuedItemCount: '{{count}} files',
    messages: {
      listFailed: 'Could not load folder list.',
      serverUnreachable: 'Could not reach the upload server.',
      loginRequired: 'You must be signed in to upload.',
      uploading: 'Uploading files…',
      tarFallback: 'Archive upload failed for some files. Falling back to direct upload…',
      tarPartial: '{{failed}} file(s) could not be archived/uploaded and were kept in the queue.',
      directPartial: '{{failed}} file(s) could not be uploaded and were kept in the queue.',
      noFiles: 'No files were selected.',
      noQueuedFiles: 'Add files or folders before uploading.',
      queueNoNewFiles: 'No new files were added; the selected items are already queued.',
      queueAdded: '{{count}} item(s) added to the queue. Folder count: {{folderCount}}',
      dropFolderReadFailed: 'Could not read the dropped folders.',
      chooseFoldersFailed: 'Could not read the selected folders.',
      relativePathMissing:
        'Folder structure data is missing. The selected items will be uploaded as flat files.',
      uploadedCount: '{{count}} file(s) uploaded to /root/uploads/{{path}}',
      uploadFailedNetwork: 'Upload failed (network error).',
      enterFolderName: 'Please enter a folder name.',
      folderCreated: 'Folder created.',
      folderCreateFailed: 'Could not create folder (network error).',
    },
  },
  itUsersList: {
    title: 'IT User List',
    loading: 'Loading users...',
    loadError: 'An error occurred while loading users.',
    columns: {
      username: 'Username',
      personnel: 'Personnel',
      personnelId: 'Personnel ID',
      role: 'Role',
      status: 'Status',
      lastLogin: 'Last Login',
    },
    filters: {
      searchPlaceholder: 'Username, personnel, personnel ID, role...',
      rolePlaceholder: 'Role',
      statusPlaceholder: 'Status',
    },
    roles: {
      admin: 'Admin',
      user: 'User',
      readonly: 'Readonly',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
  },
};

export default en;

